import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"

export default class DepartamentoAreaFormulario extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                codigo: "",
                nombre: "",
                tipo: 0,
                padre: null,
                empresa: 0,
                ubicacion: 0
            },
            colapsar: true,
            camposRequeridos: [],
            padres: [],
            empresas: [],
            ubicaciones: [],
        };
        this.actualizarValores = this.actualizarValores.bind(this);
    }

    componentDidMount() {
        this.obtenerDepartamentoAreas();
    }

    obtenerDepartamentoAreas() {
        if (this.apiRest.getRol()) {
            this.apiRest.get('/departamentoArea').then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ padres: respuesta.data });
                }
            });
            this.apiRest.get('/empresa').then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ empresas: respuesta.data });
                }
            });
            this.apiRest.get('/ubicacion').then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ ubicaciones: respuesta.data });
                }
            });
        } else {

            if (_valid(this.apiRest.getLS('idEmpresa'))) {
                this.setState(estadoAnterior => ({
                    registro: { ...estadoAnterior.registro, ['empresa']: this.apiRest.getLS('idEmpresa').id }
                }));
                this.apiRest.getArticuloEmpresa('/getDepartamentoArea/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ padres: respuesta.data });
                    }
                });
                this.apiRest.getUbicacion('/getUbicacion/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ ubicaciones: respuesta.data });
                    }
                });
            }
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    almacenarRegistro = () => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro
            if (_valid(registro.id)) {
                this.apiRest.put('/departamentoArea/' + registro.id, registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/departamentoAreaListado');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {
                this.apiRest.post('/departamentoArea', registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/departamentoAreaListado');
                        this.setState({ registro: resultado.data });
                        this.obtenerDepartamentoAreas();
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    datosRegistroValidos() {
        const { registro, camposRequeridos } = this.state;

        let existenErrores = false
        if (!_valid(registro.codigo)) {
            camposRequeridos.push("codigo");
            existenErrores = true;
        }
        if (!_valid(registro.nombre)) {
            camposRequeridos.push("nombre");
            existenErrores = true;
        }
        if (!_valid(registro.empresa) || registro.empresa == 0) {
            camposRequeridos.push("empresa");
            existenErrores = true;
        }
        if (!_valid(registro.ubicacion)) {
            camposRequeridos.push("ubicacion");
            existenErrores = true;
        }

        if (!_valid(registro.tipo) || registro.tipo == 0) {
            camposRequeridos.push("tipo");
            existenErrores = true;
        }

        if (existenErrores) {
            this.setState({ camposRequeridos: camposRequeridos });
            setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);
        }

        return !existenErrores;
    }

    render() {
        const { registro, colapsar, camposRequeridos, padres, empresas, ubicaciones } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Departamento - Área" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Departamento - Área</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="codigo" className="form-label">
                                                                        Código
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.codigo}
                                                                        onChange={this.actualizarValores}
                                                                        name="codigo"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa código"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Nombre
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombre}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombre"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa nombre"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Tipo
                                                                    </Label>
                                                                    <select
                                                                        value={registro.tipo}
                                                                        onChange={this.actualizarValores}
                                                                        name="tipo"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        <option value="1">Departamento</option>
                                                                        <option value="2">Area</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                {
                                                                    this.apiRest.getRol() ?
                                                                        <div className="mb-3 mb-4">
                                                                            <Label htmlFor="nombre" className="form-label">
                                                                                Empresa
                                                                            </Label>
                                                                            <select
                                                                                value={registro.empresa}
                                                                                onChange={this.actualizarValores}
                                                                                name="empresa"
                                                                                className="form-control"
                                                                            >
                                                                                <option value="0">Seleccionar</option>
                                                                                {empresas.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                            </select>
                                                                        </div> 
                                                                        :
                                                                        <div className="mb-3 mb-4">
                                                                            <Label htmlFor="nombre" className="form-label">
                                                                                Empresa
                                                                            </Label>
                                                                            <br/>
                                                                            {this.apiRest.getEmpresaNombre()}
                                                                        </div> 
                                                                }
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="ubicacion" className="form-label">
                                                                        Ubicación
                                                                    </Label>
                                                                    <select
                                                                        value={registro.ubicacion}
                                                                        onChange={this.actualizarValores}
                                                                        name="ubicacion"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {ubicaciones.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="ubicacion" className="form-label">
                                                                        Padre
                                                                    </Label>
                                                                    <select
                                                                        value={registro.padre}
                                                                        onChange={this.actualizarValores}
                                                                        name="padre"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {padres.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/departamentoAreaListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}